import { toast } from "sonner";
import { supabase } from "@/integrations/supabase/client";
import { CategoryItem } from "./CategoryItem";

interface CategoryListProps {
  categories: Array<{ id: string; name: string }>;
  onEdit: (category: { id: string; name: string }) => void;
  onUpdate: () => void;
}

export const CategoryList = ({ categories, onEdit, onUpdate }: CategoryListProps) => {
  const handleDelete = async (id: string) => {
    try {
      const { error } = await supabase
        .from('categories')
        .delete()
        .eq('id', id);

      if (error) {
        if (error.code === '23503') {
          toast("خطأ", {
            description: "لا يمكن حذف هذا التصنيف لأنه مستخدم في أدوات"
          });
          return;
        }
        throw error;
      }
      toast("نجاح", {
        description: "تم حذف التصنيف بنجاح"
      });
      onUpdate();
    } catch (error) {
      console.error('Error deleting category:', error);
      toast("خطأ", {
        description: "حدث خطأ أثناء حذف التصنيف"
      });
    }
  };

  return (
    <div className="grid gap-4">
      {categories.map((category) => (
        <CategoryItem
          key={category.id}
          category={category}
          onEdit={onEdit}
          onDelete={handleDelete}
        />
      ))}
    </div>
  );
};